import { FC, useCallback, useContext, useEffect, useState } from 'react';
import { useListAllActivitiesInitiatedByGmg } from 'src/graphql/useListAllActivitiesInitiatedByGmg';
import ActivityListContainer from './ActivityListContainer';
import AppContext from 'src/AppContext';

const GMGActivityContainer: FC = () => {
    const [cursorToRequest, setCursorToRequest] = useState<string | null>(null);
    const { data, isFetching, error } = useListAllActivitiesInitiatedByGmg(cursorToRequest);
    const context = useContext(AppContext);

    const requestPage = useCallback((cursor: string | null) => {
        setCursorToRequest(cursor);
    }, []);

    useEffect(() => {
        if (!error) {
            return;
        }
        context.onError(error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    return (
        <ActivityListContainer
            data={data}
            isFetching={isFetching}
            requestPage={requestPage}
            isGmGAdminView={true}
        />
    );
};

export default GMGActivityContainer;
